import { Alert, Button, TextField } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";

const FryerAdd = () =>
{
    const navigate = useNavigate();
    const [name, setName] = useState( '');
    const [hersteller, setHersteller]= useState( '');
    const [errorMessage, setErrorMessage] = useState(null); 

    const handleSubmit = async () =>{
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                'name': name,
                'hersteller': hersteller
            })
        };
        const response = await fetch('/api/fryer', requestOptions);
        if(response.ok){
            navigate('/fryer', {state: {'message': 'Der Fryer wurde erfolgreich hinzugefügt.'}});
        }else{
            const json = await response.json();
            setErrorMessage(json.message);
        }
    };

    return(
        <div className="centered">
            <Button sx={{marginLeft:'15px !important'}} fullWidth className="custom-button-root" onClick={evt => window.location.assign('/fryer')}>zurück</Button>  
            <h2>Fryer hinzufügen</h2>
            <TextField
               fullWidth
               label="Name"
               required
               onChange={(event) => setName(event.target.value)}
               value={name}
            />
            <TextField
               fullWidth
               label="Hersteller"
               required
               onChange={(event) => setHersteller(event.target.value)}
               value={hersteller}
            />
            <Button sx={{marginLeft:'15px !important'}} fullWidth className="custom-button-root" onClick={() => handleSubmit()}>Fryer hinzufügen</Button>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
        </div>
    );
}

export default FryerAdd;